export const calculationPositionsQuery = {
    populate: {
        material_type: {
            fields: ['documentId', 'name', 'materialInCutting', 'cost'],
        },
        additional_material_types: {
            fields: ['documentId', 'name', 'materialInCutting', 'cost'],
        },
        additional_materials: {
            fields: ['documentId', 'width'],
            populate: {
                material_type: {
                    fields: ['documentId', 'name'],
                },
            },
        },
        stamp: {
            fields: [
                'documentId',
                'id',
                'number',
                'width',
                'length',
                'floods',
                'range',
                'shape',
                'comment',
                'radius',
            ],
            populate: {
                roller: {
                    fields: ['documentId', 'roller'],
                },
                last_order: true, // StampNumber: только наличие relation («Новый»)
                // nested fields с name → Strapi 400 "Invalid key name"
                tube: true,
                contractor: true,
            },
        },
        material: {
            fields: ['documentId', 'width'],
        },
        // Нужны для модалки создания отгрузки (повтор заказа), не для колонок таблицы
        shipment_position: {
            fields: ['labelName', 'comment'],
            populate: {
                shipment: {
                    fields: [
                        'id',
                        'windingSchemeFace',
                        'windingSchemeTurn',
                        'package',
                        'manualLabeling',
                        'clientLabel',
                        'packageCopies',
                        'windingInfo',
                        'pallet',
                        'congreve',
                        'priming',
                        'bushing',
                        'printingOnGlueLayer',
                    ],
                    populate: {
                        designer: {
                            fields: ['documentId'],
                        },
                        form_set: {
                            fields: ['documentId', 'id'],
                        },
                        blankPreviewFiles: {
                            fields: ['id'],
                        },
                    },
                },
            },
        },
        machine_brands: {
            fields: ['documentId'],
        },
        calculated: true,
        lacquers: {
            populate: {
                type: {
                    fields: ['documentId', 'name'],
                },
            },
        },
        machine: {
            fields: ['documentId', 'name'],
            populate: {
                // validateMachine / machineHasStampRoller читают rollers из list-данных
                rollers: {
                    fields: ['documentId'],
                },
            },
        },
        additional_jobs: {
            fields: ['documentId', 'name'],
        },
        additional_machines: {
            fields: ['documentId', 'name'],
        },
        virtualStamp: {
            populate: {
                roller: {
                    fields: ['documentId', 'roller'],
                },
            },
        },
        correctMaterialCost: {
            populate: {
                material_type: {
                    fields: ['documentId', 'name'],
                },
            },
        },
    },
}
